import React, { useState } from 'react';
import googleDriveService from '../services/googleDrive';
import MarkdownViewer from './MarkdownViewer';
import { MIME_TYPES } from '../utils/config';

const DocumentViewer = ({ document }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  if (!document) {
    return (
      <div className="document-viewer">
        <div className="no-document">
          <p>No document selected</p>
        </div>
      </div>
    );
  }

  // Check if this is a markdown or text file
  const isMarkdownFile = document.mimeType === MIME_TYPES.MARKDOWN || 
                         document.mimeType === MIME_TYPES.TEXT ||
                         document.name.toLowerCase().endsWith('.md') ||
                         document.name.toLowerCase().endsWith('.markdown');

  // Use MarkdownViewer for markdown files
  if (isMarkdownFile) {
    return <MarkdownViewer document={document} />;
  }

  const embedUrl = googleDriveService.getEmbedUrl(document.id, document.mimeType);

  const handleIframeLoad = () => {
    setLoading(false);
    setError(false);
  };

  const handleIframeError = () => {
    setLoading(false);
    setError(true);
  };

  return (
    <div className="document-viewer">
      <div className="document-content">
        {loading && (
          <div className="loading-indicator">
            <div className="spinner"></div>
            <p>Loading {document.name}...</p>
          </div>
        )}

        {error && (
          <div className="error-indicator">
            <p>Failed to load {document.name}</p>
            <p>The document may be restricted or unavailable.</p>
            <a 
              href={`https://drive.google.com/file/d/${document.id}/view`}
              target="_blank"
              rel="noopener noreferrer"
              className="direct-link"
            >
              Open in Google Drive
            </a>
          </div>
        )}

        <iframe
          src={embedUrl}
          className="workspace-iframe"
          title={document.name}
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          style={{ 
            display: loading || error ? 'none' : 'block',
            width: '100%',
            height: '100%',
            border: 'none'
          }}
        />
      </div>
    </div>
  );
};

export default DocumentViewer;